var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dm-playgorund",attrs:{"href":"/tour/","target":"_blank"}},[_c('img',{attrs:{"src":"","alt":""}})])
}]

export { render, staticRenderFns }